import { forwardRef } from 'react';
import {
  Slide,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Container,
  Skeleton,
  Card,
  CardContent,
} from '@mui/material';
// hooks
import useAuth from '../../hooks/useAuth';
// components
import Iconify from '../../components/Iconify';
import {
  MatchingCrewProfile,
} from '../jobs/';
// swr
import useSWR from 'swr';
// utils
import axiosSWRFetcher from '../../utils/swrFetcher';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function CrewProfileDialog({ isOpen, closeDialog, crew }) {
  const { user } = useAuth();
  const companyId = user?.employee.company[0].id;
  const crewId = crew?.id || null;
  const { data, isValidating } = useSWR(crewId ? `/api/company/${companyId}/crews/${crewId}/` : null, axiosSWRFetcher, {errorRetryInterval: 2000, revalidateOnFocus: false});

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullScreen TransitionComponent={Transition}>
      <AppBar position="relative" color="transparent" sx={{ boxShadow: 'none' }}>
        <Toolbar sx={{ px: 0 }}>
          <Box variant="h6" sx={{ flex: 1 }} />
          <IconButton color="inherit" edge="end" onClick={closeDialog} sx={{ mt: 2, mr: 2 }}>
            <Iconify icon="eva:close-fill" />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg">
        <Typography variant="h4" sx={{ mb: 3 }}>
          프로필 상세보기
        </Typography>
        {crewId && data && !isValidating && (
          <Card>
            <CardContent>
              <MatchingCrewProfile
                isOfferRunning
                candidate={data}
                isContractRunning
              />
            </CardContent>
          </Card>
        )}
        {isValidating && (
          <Skeleton variant="rectangular" width="100%" height={400} />
        )}
      </Container>
    </Dialog>
  )
}